module.exports = __webpack_public_path__ + "static/media/reamaze-logo.17dd5f6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/reamaze-logo.jpg
// module id = 2768
// module chunks = 0